module.exports = __webpack_public_path__ + "static/media/expander_active.4a611eee.svg";